import { asyncAction } from 'lib/actions';

export const fetchArtistListAction = asyncAction('globalSearch/ARTIST');
